import Popover from "@components/ui/popover";
import { cn } from "@lib/cn";
import { IconCheck, IconSelector } from "@tabler/icons-react";
import type { Dispatch, SetStateAction } from "react";
import {
  type IStoriesFolderUser,
  StoriesFolderUserPermEnum,
} from "@/shared/types";

interface IProps {
  isPicking: boolean;
  setIsPicking: Dispatch<SetStateAction<boolean>>;
  user: IStoriesFolderUser;
  setUserType: (type: StoriesFolderUserPermEnum) => void;
}

const OPTIONS: { label: string; type: StoriesFolderUserPermEnum }[] = [
  {
    label: "Owner",
    type: StoriesFolderUserPermEnum.Owner,
  },
  {
    label: "Editor",
    type: StoriesFolderUserPermEnum.Editor,
  },
];

export const MembersDialogUserType = ({
  isPicking,
  setIsPicking,
  user,
  setUserType,
}: IProps) => {
  return (
    <Popover
      open={isPicking}
      onOpenChange={setIsPicking}
      placement="bottom-end"
    >
      <Popover.Trigger
        className={cn(
          "tw-flex tw-h-9 tw-cursor-pointer tw-items-center tw-rounded-md tw-px-3 tw-font-sans tw-text-sm tw-font-medium tw-text-blue tw-transition-colors hover:tw-bg-blue-100",
          isPicking && "tw-bg-blue-100",
        )}
      >
        {user.status === StoriesFolderUserPermEnum.Editor ? "Editor" : "Owner"}
        <IconSelector className="tw-ml-2 tw-size-4 tw-text-blue-500" />
      </Popover.Trigger>
      <Popover.Content
        className="tw-z-[10000] tw-w-40 tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-p-1 tw-shadow-md"
        data-sd-is-floating-popover
      >
        {OPTIONS.map((opt) => (
          <Option
            key={opt.type}
            label={opt.label}
            type={opt.type}
            user={user}
            setIsPicking={setIsPicking}
            setUserType={setUserType}
          />
        ))}
      </Popover.Content>
    </Popover>
  );
};

interface IOptionProps {
  label: string;
  user: IStoriesFolderUser;
  type: StoriesFolderUserPermEnum;
  setUserType: IProps["setUserType"];
  setIsPicking: IProps["setIsPicking"];
}

const Option = ({
  label,
  type,
  user,
  setIsPicking,
  setUserType,
}: IOptionProps) => {
  return (
    <button
      type="button"
      onClick={() => {
        setUserType(type);
        setIsPicking(false);
      }}
      className="tw-flex tw-h-9 tw-w-full tw-cursor-pointer tw-items-center tw-rounded tw-px-2 tw-font-sans tw-text-sm tw-text-blue tw-outline-none tw-transition-colors hover:tw-bg-blue-100"
    >
      {label}
      {user.status === type && (
        <IconCheck className="tw-ml-auto tw-size-4 tw-text-blue" />
      )}
    </button>
  );
};
